import { ApplicationConfig, ErrorHandler, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import * as Sentry from '@sentry/angular';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { provideAnalytics } from './core/analytics/analytics.service';
import { DEFAULT_LANG } from './core/locale.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(),
    provideTranslateService({
      fallbackLang: DEFAULT_LANG,
      loader: provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' }),
    }),
    provideAnalytics(),
    environment.production ? { provide: ErrorHandler, useValue: Sentry.createErrorHandler() } : [],
  ],
};
